
import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from "./router";
import VueTilt from "vue-tilt.js";
import VueSweetalert2 from "vue-sweetalert2";
import SoftUIDashboard from "./medical";
import { i18n } from "./project/Source/lang/i18n";
import { initAgentTheme } from "./project/Source/agentTheme.js";

initAgentTheme();

function updateCssVariables() {
    const domain = window.location.hostname;
    const root = document.documentElement;

    if (domain === 'medical-hp.progress-ims.com') {
        root.style.setProperty('--info-color', '#a72923');
    } else {
        root.style.setProperty('--info-color', '#E83229');
    }
}
updateCssVariables();
const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(i18n);
appInstance.use(ElementPlus)
appInstance.use(VueTilt);
appInstance.use(VueSweetalert2); 
appInstance.use(SoftUIDashboard);
appInstance.mount("#app");
